(() => {
  'use strict';
  if (window.AWP0PrepublicationPrewarm?.version) return;

  const VERSION = '1.2.1-p03-exact-context-sync';
  const path = String(location.pathname || '').replace(/\/+$/, '') || '/';
  const isMonAtelier = path === '/pages/mon-atelier-airsoft';
  const isCompatibility = path.includes('/pages/compatibilite-airsoft');
  if (!isMonAtelier && !isCompatibility) {
    window.AWP0PrepublicationPrewarm = { version:VERSION, active:false };
    return;
  }

  const syncExactContext = (reason = 'model-index-ready') => {
    try {
      const api = window.AWGarageExactContextP2;
      if (!api?.apply) return false;
      api.apply(`p03:${reason}`);
      return true;
    } catch (_) { return false; }
  };
  const syncExactWhenReady = (reason = 'model-index-ready') => {
    if (syncExactContext(reason)) return;
    [50, 200, 800].forEach((delay) => window.setTimeout(() => syncExactContext(`${reason}:${delay}`), delay));
  };

  const afterLoad = () => {
    try { window.AWOwnedReplicaContext?.refreshGarage?.(); } catch (_) {}
    try { window.AWGarageExactModelPoolP2?.render?.(); } catch (_) {}
    try { window.AWGarageExactModelAssistant?.render?.(); } catch (_) {}
    syncExactWhenReady('after-index-load');
    try { window.AWCompatibilityP1Core?.refresh?.(); } catch (_) {}
    try { window.AWCompatibilityUXContextP1?.render?.(); } catch (_) {}
  };

  window.addEventListener('aw:model-index-ready', () => syncExactWhenReady('aw:model-index-ready'));

  const loadIndex = () => {
    if (window.__awP0PrepublicationIndexPrewarm) return;
    window.__awP0PrepublicationIndexPrewarm = true;
    Promise.resolve(window.AWReplicaModelIndex?.load?.())
      .catch(() => null)
      .finally(() => {
        afterLoad();
        window.dispatchEvent(new CustomEvent('aw:p0-prepublication-index-prewarm-ready', { detail:{ path } }));
      });
  };

  let started = false;
  const start = (reason) => {
    if (started) return;
    started = true;
    document.documentElement.dataset.awP0PrepublicationPrewarm = reason;
    loadIndex();
  };

  if (isCompatibility) {
    const params = new URL(location.href).searchParams;
    if (String(params.get('aw_from') || '').toLowerCase() === 'garage') {
      start('compatibility-garage-deeplink');
    } else {
      window.addEventListener('aw:compatibility-nav-secondary-ready', () => start('compatibility-secondary-ready'), { once:true });
      window.setTimeout(() => start('compatibility-fallback'), 1800);
    }
  } else if (isMonAtelier) {
    window.addEventListener('aw:atelier-nav-secondary-ready', () => start('atelier-secondary-ready'), { once:true });
    window.setTimeout(() => start('atelier-fallback'), 1600);
  }

  if (window.AWReplicaModelIndex?.available === true) syncExactWhenReady('index-already-ready');

  window.AWP0PrepublicationPrewarm = { version:VERSION, active:true, path, loadIndex, start, afterLoad, syncExactContext };
})();
